export default __webpack_public_path__ + "static/media/union.c958ffcc.svg";